<mat-form-field
    class="form-full-width"
    appearance="outline"
    [formGroup]="service.group">
    <ng-container *ngIf="service.field?.leadingIcon">
        <i matPrefix
           [ngClass]="'mdi mdi-' + service.field?.leadingIcon"
           class="select_leading-icon"></i>
    </ng-container>

    <mat-label>{{service.field?.label}}</mat-label>

    <fui-button
        class="select_trailing-button"
        icon="chevron-down"
        type="button-icon"
        height="mini"
        borderRadius="circle"
        color="neutral"
        [disabled]="service.field.disabled">
    </fui-button>

    <mat-select  #matSelect
                 [panelClass]="service.field.bottom ? 'mat-select-search-panel-bottom' : ''"
                 [formControl]="service?.group.get(service.field?.name)"
                 [multiple]="service.field.multiple"
                 [fuiTooltip]="tooltip | async">
        <mat-option [value]="" *ngIf="!service.field.required && !service.field.multiple && !service.field.withoutChooseField"
                    (click)="service.group.get(service.field.name).setValue(null)">
            {{appService.language_dictionary.system_not_specified_upp_case}}
        </mat-option>
        <mat-option *ngFor="let option of service.field.options" [value]="option.id" [matTooltip]="option.name">
            <ng-container *ngIf="option?.icon">
                <div class="select-div">
                    <span class="select-icon"><i [class]="option?.icon"></i></span>
            {{option.name}}
                </div>
            </ng-container>
            <ng-container *ngIf="!option?.icon">
                {{option.name}}
            </ng-container>
        </mat-option>
    </mat-select>
    <ng-container *ngFor="let validation of service.field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="service.group?.get(service.field.name)?.hasError(validation.name)"
                   [innerHTML]="validation.name == 'serverError' ? service.group?.get(service.field.name)?.errors?.serverError : validation.message">
        </mat-error>
    </ng-container>
    <mat-hint *ngIf="this.service.field.hint" [innerHtml]="this.service.field.hint" [ngClass]="'select_tooltip'" [title]="this.service.field.hint"></mat-hint>
</mat-form-field>
